import { Box, Link, Typography } from "@mui/material";
import React from "react";
import { useMetadataQuery } from "../../../../common/hooks/metadata/useMetadataQuery";
import { useResponsiveness } from "../../../../common/hooks/utils/useResponsiveness";

export const InvitationHeaderSummary: React.FC = () => {
  const { data: metadata } = useMetadataQuery();
  const { isMedium } = useResponsiveness();
  const { professionalReferralsCount = 0, accountInquiriesCount = 0 } =
    metadata ?? {};

  return (
    <Box
      display="flex"
      flexDirection="column"
      rowGap={0.5}
      width={isMedium ? "100%" : "35%"}
    >
      <Box display="flex" flexDirection="column" rowGap={1.5}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
          }}
        >
          Job Request Inquiries
        </Typography>
        <Typography variant="subtitle2">
          You placed {metadata?.accountInquiriesCount ?? "-"} job request
          inquiry(ies)
        </Typography>
        {accountInquiriesCount > 0 && (
          <Typography variant="subtitle2">
            <Link href="/inquiries/">View Job Inquiries Page</Link>
          </Typography>
        )}
      </Box>
      <Box display="flex" flexDirection="column" rowGap={0.5}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
          }}
        >
          Job Referrals from Pros
        </Typography>
        <Typography variant="subtitle2">
          You are referred to {metadata?.professionalReferralsCount ?? "-"}{" "}
          projects
        </Typography>
        {professionalReferralsCount > 0 && (
          <Typography variant="subtitle2">
            <Link href="/professional-referrals/">View Referrals Page</Link>
          </Typography>
        )}
      </Box>
    </Box>
  );
};
